<template>
    <div>
        <router-view v-if="$route.name === 'messages.inbox.view'"></router-view>
        
        <div v-else class="mg-b-20 mg-lg-b-25 mg-xl-b-30">
            <div v-if="loading" class="mg-t-20">
                <spinner-component :loading="loading"/>
            </div>

            <div v-if="error" class="tx-center tx-danger mg-t-20">
                {{ error }}
            </div>

            <div v-else class="row justify-content-center">
                <div class="col-lg-9 pd-x-0 pd-x-0">
                    <div v-if="!messages && !loading" class="mg-t-20">
                        <h5 class="tx-color-01 mg-b-5 tx-center">Inbox Empty.</h5>
                        <p class="tx-color-03 tx-13 tx-center">You do not have any messages at the moment.</p>
                    </div>

					<div v-if="messages">
                        <client-inbox-list :messages="messages" :type="'inbox'"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		mounted() {},
		data() {
			return {
				loading: false,
				messages: null,
				error: null
			};
		},
		created() {
			if (this.$route.name === "messages.inbox") {
				this.fetchMessages();
			}
		},
		watch: {
			$route: "fetchMessages"
		},
		methods: {
			fetchMessages() {
				this.error = this.messages = null;
				this.loading = true;

				axios
					.get("/api/messages", {
						params: {
							client: this.$store.getters.company
								.external_client_id,
							type: "receive"
						}
					})
					.then(response => {
						const messages = response.data.data.messages;

						if (!_.isEmpty(messages)) {
							this.messages = messages;
						}
					})
					.catch(error => {
						this.error = error.toString();
					})
					.finally(() => {
						this.loading = false;
					});
			}
		}
	};
</script>
